import { createApp } from 'vue'

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'

import * as Sentry from "@sentry/vue"

import './assets/main.css'
import 'vue-search-select/dist/VueSearchSelect.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

library.add(faLock)
library.add(faLockOpen)

const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://55bd69415d8796b2cbeecc9148861b95@o297454.ingest.us.sentry.io/4505664697139200",
  allowUrls: ['gdo.mmarsh.co', 'cardinate.darknova.co'],
  tracesSampleRate: 1.0
})

app.use(pinia)

app.component('font-awesome-icon', FontAwesomeIcon)

app.mount('#app')
